import { useValidation } from '@xengage/gw-portals-validation-react';
import { AddressStandardizationServiceCC } from 'twia-capability-fnol-addressstandardization';
import { TWIAAddressComponent } from 'twia-capability-address-component';
import addressControl from 'twia-capability-address-component/util/addressControl';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import _ from 'lodash';
import React, { useCallback, useEffect, useState, useContext } from 'react';
import Address from '../../models/Address';
import metadata from './InjuredPartyForm.metadata.json5';
import styles from './InjuredPartyForm.module.scss';

const fillAddress = (addressVM, injuredPartyVM, isEditInjuredPartyForm) => {
    if (isEditInjuredPartyForm && _.get(injuredPartyVM.value, 'isAddressRequired')) {
        _.set(addressVM, 'value',
            _.get(injuredPartyVM, 'injuryIncidentContact.primaryAddress.value')
        );
        return addressVM;
    }
    return addressVM;
}

const InjuredPartyForm = props => {
    const viewModelService = useContext(ViewModelServiceContext);
    const {
        injuredPartyVM,
        claimVM,
        setEditInjuredPartyForm,
        isEditInjuredPartyForm,
        updateWizardData,
        setShowInjuredPartyForm,
        onValidate
    } = props;
    const injuryIncidentAddrVM = viewModelService.create(
        new Address(),
        'cc',
        'edge.capabilities.address.dto.AddressDTO'
    );
    const {
        isComponentValid,
    } = useValidation('InjuredPartyForm');
    const { authHeader } = useAuthentication();
    const [incidentVM, updateIncidentVM] = useState(injuredPartyVM);
    const [addressVM, setAddressVM] = useState(fillAddress(injuryIncidentAddrVM, injuredPartyVM, isEditInjuredPartyForm));
    const [ccConstants, setCCConstants] = useState([]);
    const [isStandardizationDisabled, setIsStandardizationDisabled] = useState(false);
    const [isButtonDisabled, updateDisablity] = useState(false);
    const [invalidComponent, setInvalidComponents] = useState([]);
    const [ isAddressEdited, setIsAddressEdited ] = useState(false);
    const country = _.get(injuryIncidentAddrVM, 'country.value.code');
    const xPortal = 'CC';
    const [showErrors, setShowErrors] = useState(false);
    const [showAddress, setShowAddress] = useState(false);

    const getCCConstants = useCallback(async () => {
        const constants = await AddressStandardizationServiceCC.getCCPortalConstants(authHeader);
        if (!constants.portalAddressStandardizationEnabled) {
            setIsStandardizationDisabled(true);
            updateDisablity(true);
        }
        setCCConstants(constants);
    }, []);

    useEffect(() => {
        getCCConstants();
        if(_.isUndefined(_.get(addressVM, 'mustStandardize_Ext.value'))){
            _.set(addressVM, 'mustStandardize_Ext.value', true);
            _.set(addressVM, 'addressVerifyStatusExt.value', 'notvalidated');
            setAddressVM(addressVM);
        }
    }, [addressVM]);

    const findInvalidComponent = useCallback((isValid, componentID) => {
        if (isValid === false) {
            setInvalidComponents((oldValue) => [...oldValue, componentID]);
        }

        if (isValid === true) {
            setInvalidComponents((oldValue) => oldValue.filter((val) => val !== componentID));
        }
    }, []);

    const setDisablity = useCallback((value) => {
        if (!isStandardizationDisabled) {
            updateDisablity(false);
        }
        else {
            updateDisablity(addressControl.isStdBtnAvailable(value, xPortal))
        }
    }, [updateDisablity]);

    const updatePolicyAddressVM = useCallback((addrssVM) => {
        if (addrssVM) {
            //setAddressVM(addrssVM);
            _.set(incidentVM, 'injuryIncidentContact.primaryAddress', addrssVM);
            setDisablity(addrssVM);
            if(addrssVM?.addressVerifyStatusExt === 'validated') {
                _.set(incidentVM, 'injuryIncidentContact.primaryAddress.isValidated_Ext', true);
                setIsAddressEdited(false);
                updateIncidentVM(incidentVM);
                setAddressVM(incidentVM.injuryIncidentContact.primaryAddress);
            } else if(addrssVM?.addressVerifyStatusExt === 'overridden') {
                _.set(incidentVM, 'injuryIncidentContact.primaryAddress.isOverridden_Ext', true);
                setIsAddressEdited(false);
                updateIncidentVM(incidentVM);
                setAddressVM(incidentVM.injuryIncidentContact.primaryAddress);
            }
            updateIncidentVM(incidentVM);
            updateWizardData(claimVM);
        }
       
    }, [incidentVM, updateIncidentVM, setDisablity, claimVM]);

    const handleAddressEditing = useCallback((val) => {
        setIsAddressEdited(val);
    });

    const okAction = useCallback(() => {
        const incidentSubtreeNotValid = _.get(incidentVM, 'aspects.invalidChildProperties').some(
            (item) => !item.includes('primaryAddress')
        );
        if (!_.get(incidentVM, 'aspects.valid')
            || incidentSubtreeNotValid
            || !_.get(incidentVM, 'injuryIncidentContact.aspects.valid')
            || (_.get(incidentVM, 'isAddressRequired.value') && invalidComponent.length)) {
            setShowErrors(true);
            return;
        }
        if (!_.get(incidentVM, 'isAddressRequired.value')) {
            _.set(incidentVM, 'injuryIncidentContact.primaryAddress.value', undefined);
        }
        const existingIndex = claimVM.incidents?.value?.findIndex((item) => {
            return item.tempID === _.get(incidentVM.value, 'tempID');
        });
        if (existingIndex > -1) {
            _.set(claimVM, `incidents.value[${existingIndex}]`, incidentVM.value);
        } else {
            claimVM.incidents.value.push(incidentVM.value);
        }
        updateWizardData(claimVM);
        setShowInjuredPartyForm(false);
        setEditInjuredPartyForm(false);
    }, [incidentVM, claimVM]);

    const cancelAction = () => {
        setShowInjuredPartyForm(false);
        setEditInjuredPartyForm(false);
    };

    const writeValue = useCallback((value, path) => {
        _.set(incidentVM, path, value);
    
        if (path === 'isAddressRequired') {
            if (!value) {
                // _.set(incidentVM, 'injuryIncidentContact.primaryAddress.value', undefined);
                // _.set(addressVM, 'value', undefined);
                // setAddressVM(prevState => ({ ...prevState, value: undefined }));
                setShowAddress(false);
                setIsAddressEdited(false);
            } else {
                _.set(injuryIncidentAddrVM, 'mustStandardize_Ext.value', true);
                _.set(injuryIncidentAddrVM, 'addressVerifyStatusExt.value', 'notvalidated');
                setAddressVM(injuryIncidentAddrVM);
                setShowAddress(true);
            }
        }
    
        updateIncidentVM(incidentVM);
        updateWizardData(claimVM);
    }, [incidentVM, addressVM, injuryIncidentAddrVM, updateIncidentVM, updateWizardData]);
    

    const resolvers = {
        componentMap: {
            addressComponent: TWIAAddressComponent
        },
        callbackMap: {
        },
    };

    const overrideProps = {
        '@field': {
            showOptional: false,
            showRequired: true
        },
        okButton: {
            onClick: okAction,
            disabled: isAddressEdited
        },
        cancelButtonId: {
            onClick: cancelAction
        },
        injuryIncidentAddressComponent: {
            addressVM, updatePolicyAddressVM, country, showErrors, findInvalidComponent, onValidate, authHeader,
            companyType : 'tfpa',
            xPortal,
            ccConstants,
            isStandardizationDisabled,
            onAddressEdit: handleAddressEditing,
            visible: showAddress || !!_.get(incidentVM, 'isAddressRequired.value'),
            isLossLocation: true
        }
       
    };

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={incidentVM}
            onValidationChange={onValidate}
            onValueChange={writeValue}
            overrideProps={overrideProps}
            classNameMap={styles}
            showErrors={showErrors}
            {...resolvers}
        />
    );
};

export default InjuredPartyForm;
